import djinn from "./djinn.png";
import dwarf from "./dwarf.png";
import elf from "./elf.png";
import ent from "./ent.png";
import fullDjinn from "./full-djinn.jpg";
import fullDwarf from "./full-dwarf.jpg";
import fullElf from "./full-elf.jpg";
import fullEnt from "./full-ent.jpg";
import fullGiant from "./full-giant.jpg";
import fullHobbit from "./full-hobbit.jpg";
import fullHuman from "./full-human.jpg";
import fullNecromancer from "./full-necromancer.jpg";
import fullOrc from "./full-orc.jpg";
import fullVampire from "./full-vampire.jpg";
import giant from "./giant.png";
import hobbit from "./hobbit.png";
import human from "./human.png";
import necromancer from "./necromancer.png";
import orc from "./orc.png";
import vampire from "./vampire.png";

export const portraits: {[keys: string]: any} = {
  djinn,
  dwarf,
  elf,
  ent,
  giant,
  hobbit,
  human,
  necromancer,
  orc,
  vampire
};

export const figures: {[keys: string]: any} = {
  djinn: fullDjinn,
  dwarf: fullDwarf,
  elf: fullElf,
  ent: fullEnt,
  giant: fullGiant,
  hobbit: fullHobbit,
  human: fullHuman,
  necromancer: fullNecromancer,
  orc: fullOrc,
  vampire: fullVampire
}
